import React, { useState, useEffect } from 'react'
import EventItem from './event-item'

import { anyMembershipTickets, isStandalone } from '../helpers/logic'
import { ticketsWithConstituencyPricing } from '../../shared/helpers/logic'
import { getRemainingTickets } from '../../services/api'
import { Loading } from '../../shared/components'
import { has } from 'lodash-es'

function EventItemContainer({
  date,
  dependencies,
  items,
  adjustTickets,
  cartHasMembership,
  updateNeeded,
  membership
}) {
  const [showSingleUpdateLink, setShowSingleUpdateLink] = useState(false)
  const [loading, setLoading] = useState(true)

  const standaloneItems = items.filter(isStandalone)
  let standaloneUpdateItem = null
  if (standaloneItems.length === 1) {
    standaloneUpdateItem = standaloneItems[0]
  }

  const ticketsWithConstituencyPricingIds = ticketsWithConstituencyPricing(
    standaloneUpdateItem?.tickets
  ).map(t => t.priceTypeId)

  const fetchRemainingTickets = async id =>
    (await ticketsWithConstituencyPricingIds.length) > 0
      ? getRemainingTickets(
          id,
          standaloneUpdateItem.productId,
          ticketsWithConstituencyPricingIds
        )
      : getRemainingTickets(id)

  useEffect(() => {
    if (membership.active && standaloneUpdateItem) {
      const memberPricingTicketsExist = has(
        standaloneUpdateItem.pricing,
        'member'
      )
      fetchRemainingTickets(standaloneUpdateItem.externalId).then(
        ({ remainingMembershipTickets }) => {
          // showSingleUpdateLink determines whether 'there are member tickets available for this DAY' shows
          if (remainingMembershipTickets == 0 || !memberPricingTicketsExist) {
            setShowSingleUpdateLink(false)
          } else if (
            items.some(item => !anyMembershipTickets(item.tickets)) &&
            updateNeeded
          ) {
            setShowSingleUpdateLink(true)
          }
          setLoading(false)
        }
      )
    } else {
      setLoading(false)
    }
  }, [])

  if (loading) {
    return <Loading />
  }
  return (
    <React.Fragment>
      <p className="large-text">{date}</p>
      {showSingleUpdateLink && (
        <p>
          <span className="font-bold">
            There is membership pricing available for this day.
          </span>{' '}
          <span
            data-testid="standalone-update"
            className="text-link"
            onClick={adjustTickets(
              standaloneUpdateItem.occursAt,
              standaloneUpdateItem.nativeEventId
            )}
          >
            Please click here to update.
          </span>
        </p>
      )}

      {items.map(item => (
        <EventItem
          key={item.id}
          items={items}
          item={item}
          cartHasMembership={cartHasMembership}
          membership={membership}
          dependencies={dependencies}
          showSingleUpdateLink={showSingleUpdateLink}
          updateNeeded={updateNeeded}
          adjustTickets={adjustTickets}
        />
      ))}
    </React.Fragment>
  )
}

export default EventItemContainer
